
/* eslint-disable */
import { defineComponent, reactive, ref, computed, watch, getCurrentInstance, onMounted } from "vue";
import Validations from "@/core/validations";
import { FormInstance } from "element-plus";
import { Travel, Traveller } from "@/core/types";
import { loading, svgLoading, focus, dates as dDate, trip_dates_filter } from "@/store/stateless"
import moment from "moment";

export default defineComponent({
  name: 'reviewMemberFormComponent',
  props: {
    item: {
      type: Object,
      required: true,
      default: {} as Traveller,
    },
    counting: {
      type: Number,
      required: true,
      default: 1
    },
    insurance: {
      type: Array,
      required: true,
      default: () => [] as any
    },
    review_info: {
      type: Object,
      required: true,
      default: {} as Travel,
    },
    is_api_plan: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  setup(_) {
    const formReviewMember = ref<FormInstance>();
    
    const language = computed(() => {
      return window.localStorage.getItem('language');
    })

    const isOrient = ref(process.env.VUE_APP_ORIENT_INSURANCE_ID);
    const isIsa = ref(process.env.VUE_APP_ISA_INSURANCE_ID);
    const isGts = ref(process.env.VUE_APP_GTS_INSURANCE_ID);

    const defaultDob = computed(() => {
      return moment().subtract(30,'y').format('YYYY-MM-DD')
    })

    const previousTraveller = (count) => {
        console.log(count);
        loading.value = true
       setTimeout(() => {
          window.localStorage.setItem('traveller_index', JSON.stringify(count - 1))
          _.review_info.travellers_info[count].is_editable = false;
          if(_.review_info.travellers_info[count - 1] != undefined) {
              _.review_info.travellers_info[count - 1].is_editable = true;
          }
          loading.value = false
          scrollTo({ top: 120 })
       }, 500);
        return '';
    }

    const vv_type = (rule: any, value: any, callback: any) => {
        if (
        !value
        )
        callback(new Error(
            language.value === "ar" ? "الرجاء تحديد النوع" : "Please select type"
        ))
        else callback();
    };

    // const vv_passport = (rule: any, value: any, callback: any) => {
    //     if (
    //     // _.review_info.invoice?.insurance_provider_id == parseInt(isOrient.value) &&
    //     !value
    //     )
    //     callback(new Error(language.value === 'ar' ? 'الرجاء إدخال رقم جواز السفر' : `Please enter passport number`));
    //     else callback();
    // };

    const vv_gender = (rule: any, value: any, callback: any) => {
      if ((_.review_info.invoice?.insurance_provider_id == parseInt(isIsa.value) && !value) || (_.review_info.invoice?.insurance_provider_id == parseInt(isGts.value) && !value))  callback( new Error( language.value === "ar" ? "الرجاء تحديد الجنس" : "Please select gender" ) );
        else callback();
    };

    const vv_country_of_residence = (rule: any, value: any, callback: any) => {
        if ((_.review_info.invoice?.insurance_provider_id == parseInt(isIsa.value) && !value) || (_.review_info.invoice?.insurance_provider_id == parseInt(isGts.value) && !value) || !value) callback(new Error(language.value === 'ar' ? 'الرجاء اختيار بلد الإقامة' :  `Please select country of residence`));
        else callback();
    };

    const vv_nationality_id = (rule: any, value: any, callback: any) => {
      if ((_.review_info.invoice?.insurance_provider_id == parseInt(isIsa.value) && !value) || (_.review_info.invoice?.insurance_provider_id == parseInt(isGts.value) && !value) || !value) callback(new Error(language.value === 'ar' ? 'الرجاء اختيار بلد الإقامة' :  `Please select nationality`));
        else callback();
    };

    const vv_relationship = (rule: any, value: any, callback: any) => {
      if ((_.review_info.invoice?.insurance_provider_id == parseInt(isGts.value) && !value)) callback(new Error(language.value === 'ar' ? 'الرجاء اختيار بلد الإقامة' :  `Please select relationship`));
        else callback();
    };
  
    const rules = reactive({
        type: [{ validator: vv_type, trigger: ["blur", "change"] }],
        first_name: [{ validator: Validations.names, trigger: ["blur", "change"] }],
        middle_name: [{ validator: Validations.names, trigger: ["blur", "change"] }],
        last_name: [{ validator: Validations.names, trigger: ["blur", "change"] }],
        dob: [{ validator: Validations.dob, trigger: ["blur", "change"] }],
        passport: [{ validator: Validations.passportNumber, trigger: ["blur", "change"] }],
        gender_id: [{ validator: vv_gender, trigger: ["blur", "change"] }],
        nationality_id: [{ validator: vv_nationality_id, trigger: ["blur", "change"] }],
        relationship_type_id: [{ validator: vv_relationship, trigger: ["blur", "change"] }],
        country_id: [{ validator: vv_country_of_residence, trigger: ["blur", "change"] }],
     });

  const inst = getCurrentInstance()
  watch(() => focus.review, (newValue, oldValue) => {
    if(newValue != oldValue) {
      const toFocus:any = inst?.refs[newValue]
      if(toFocus != undefined) toFocus.focus()
    }
  })

  const showForIsa = computed(()=>{
    const providerId = _.review_info?.invoice?.insurance_provider_id ?? 0;
    return [parseInt(isIsa.value)].includes(parseInt(providerId));
  });

  const showForGts = computed(()=>{
    const providerId = _.review_info?.invoice?.insurance_provider_id ?? 0;
    return [parseInt(isGts.value)].includes(parseInt(providerId));
  });

  const showForOrient = computed(()=>{
    const providerId = _.review_info?.invoice?.insurance_provider_id ?? 0;
    return [parseInt(isOrient.value)].includes(parseInt(providerId));
  });

  const allowAlphabetsOnly = ($event) => (language.value === 'en' ? (/[a-zA-Z_ \s'-]/i.test($event.key)) : '');
  const allowAlphaNumeric  = ($event) => (language.value === 'en' ? (/[a-zA-Z0-9' ]/i.test($event.key)) : '');

  onMounted(async () => {
    return _.item.country_id = showForGts.value && _.review_info.source_id === 99 ? 99 : _.item.country_id
  });

  const isDisabledCountryOfResidence = computed(() => showForGts.value && _.review_info.source_id === 99 )


  function calculateAids(dob) {
      if(!dob)
      return 0

      const today = new Date();
      const birthDate = new Date(dob);
      
      let aids = today.getFullYear() - birthDate.getFullYear();
      const month = today.getMonth() - birthDate.getMonth();
      
      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
          aids--;
      }
      return aids;
  }

  function relationshipFilter(dob, mainRelations, withoutRelations)
  {
    let existing = _.counting == 0 ? mainRelations : withoutRelations

    if(calculateAids(dob) < 18) {
      existing = existing.filter(ex => ex.value != 1)
    }

    return existing
  }

    return {
      relationshipFilter,
      isDisabledCountryOfResidence,
        svgLoading,
        loading,
        focus,
        dDate,
        rules,
        isIsa,
        isOrient,
        defaultDob,
        language,
        previousTraveller,
        formReviewMember,
        trip_dates_filter,
        showForIsa,
        showForOrient,
        allowAlphabetsOnly,
        allowAlphaNumeric,
        isGts,
        showForGts,
    }
  },
  // computed: {
  //   isDisabledCountryOfResidence() {
  //     return this.showForGts && this.review_info.source_id === 99 ? true : false;
  //   }
  // },
});
